import Image from "next/image";
import { useState } from "react";
import styles from "./index.module.scss";
import { FormattedMessage, useIntl } from "react-intl";
import { handleImageLink } from "../../helpers/functions";
import { Col, Row } from "react-bootstrap";
import PdfDownloadIcon from "../../../assets/images/svg/download.svg";
import ExpandIcon from "../../../assets/images/svg/expand.svg";
import SarIcon from "../../../assets/images/svg/sar.svg";
import Link from "next/link";
import RequestForm from "../../Shared/RequestForm";

export default function SingleCountry({ data }) {
  const { locale } = useIntl();
  const [expandedImage, setExpandedImage] = useState("");
  const [isRequestOpen, setIsRequestOpen] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);

  const handlePdfDownload = async (item) => {
    const pdfUrl = item?.name?.file;

    const response = await fetch(pdfUrl);
    const blob = await response.blob();

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${item?.name?.ar}.pdf`;
    link.click();

    window.URL.revokeObjectURL(link.href);
  };

  const handleExpandImage = (item) => {
    const imageUrl = handleImageLink(item?.name?.pdfImage);
    if (!imageUrl) return;

    setExpandedImage(imageUrl);
  };

  const handleOpenRequestModal = (person) => {
    setSelectedPerson(person);
    setIsRequestOpen(true);
  };

  return (
    <div className={styles.countryPage}>
      <div
        className={
          data?.title && data?.description
            ? "top d-flex align-items-center gap-4"
            : "top d-flex align-items-center gap-4 justify-content-center"
        }
      >
        <div className="img">
          <Image
            src={handleImageLink(data?.image) || ""}
            alt=""
            width={100}
            height={100}
          />
          <p>{data?.name?.[locale]}</p>
        </div>
        {data?.title && data?.description && (
          <div className="info">
            <h3>{data?.title?.[locale]}</h3>
            <p>{data?.description?.[locale]}</p>
          </div>
        )}
      </div>
      <div className="personnels">
        <Row>
          {data?.personnels?.length > 0 ? (
            data?.personnels?.map((item, index) => {
              if (item?.available)
                return (
                  <Col xxl={3} lg={4} md={6} sm={12} key={"personnel" + index}>
                    <div className="personnel">
                      <div className="img">
                        <Image
                          src={handleImageLink(item?.name?.pdfImage)}
                          alt=""
                          width={500}
                          height={500}
                        />
                        <button
                          type="button"
                          className="pdf-btn"
                          onClick={() => handlePdfDownload(item)}
                        >
                          <Image
                            src={PdfDownloadIcon}
                            alt=""
                            width={16}
                            height={16}
                          />
                          <FormattedMessage id="downloadPdf" />
                        </button>
                        <button
                          type="button"
                          className="expand-btn"
                          onClick={() => handleExpandImage(item)}
                        >
                          <Image
                            src={ExpandIcon}
                            alt=""
                            width={16}
                            height={16}
                          />
                          <FormattedMessage id="expandImage" />
                        </button>
                      </div>
                      <div className="info">
                        <h3>{item?.name?.[locale]}</h3>

                        <ul>
                          <li>
                            <span className="key">
                              <FormattedMessage id="nationality" />:{" "}
                            </span>
                            {item?.country?.name?.[locale]}
                          </li>
                          <li>
                            <span className="key">
                              <FormattedMessage id="code" />:
                            </span>
                            {item?.id}
                          </li>

                          <li>
                            <span className="key">
                              <FormattedMessage id="religion" />:{" "}
                            </span>
                            {item?.religion?.[locale]}
                          </li>
                          <li>
                            <span className="key">
                              <FormattedMessage id="experienceYears" />:{" "}
                            </span>
                            {item?.name?.experienceYears}
                          </li>
                          <li>
                            <span className="key">
                              <FormattedMessage id="age" />:
                            </span>
                            {item?.age} <FormattedMessage id="year" />
                          </li>
                          <li>
                            <span className="key">
                              <FormattedMessage id="job" />:
                            </span>
                            {item?.job?.[locale]}
                          </li>
                          {item?.salary && (
                            <li>
                              <span className="key">
                                <FormattedMessage id="monthlySalary" />:
                              </span>{" "}
                              {item?.salary}
                              <Image
                                src={SarIcon}
                                alt=""
                                width={18}
                                height={18}
                                className="mx-1"
                              />
                            </li>
                          )}
                          {item?.recruitmentFees && (
                            <li>
                              <span className="key">
                                <FormattedMessage id="recruitmentFees" />:
                              </span>{" "}
                              {item?.recruitmentFees}
                              <Image
                                src={SarIcon}
                                alt=""
                                width={18}
                                height={18}
                                className="mx-1"
                              />
                            </li>
                          )}
                        </ul>
                        <div className="btns d-flex align-items-center justify-content-between gap-3">
                          <button
                            type="button"
                            className="open-request-modal nw-btn"
                            onClick={() => handleOpenRequestModal(item)}
                          >
                            <FormattedMessage id="recruitmentRequest" />
                          </button>
                          <Link href={`/personnel/${item?.id}`} legacyBehavior>
                            <a className="details-link nw-btn">
                              <FormattedMessage id="viewDetails" />
                            </a>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Col>
                );
            })
          ) : (
            <Col xs={12}>
              <p className="no-data text-center alert alert-info">
                <FormattedMessage id="noPersonnels" />
              </p>
            </Col>
          )}
        </Row>
      </div>
      {expandedImage && (
        <div className="zoom-image" onClick={() => setExpandedImage("")}>
          <Image src={expandedImage} width={1200} height={1200} alt="" />
        </div>
      )}
      {isRequestOpen && (
        <div className="request-modal" onClick={() => setIsRequestOpen(false)}>
          <div
            className="request-modal-content"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="request-modal-header">
              <h3>
                <FormattedMessage id="recruitmentRequest" />
              </h3>
              <button
                type="button"
                className="request-modal-close"
                onClick={() => setIsRequestOpen(false)}
                aria-label="close"
              >
                ×
              </button>
            </div>
            <RequestForm
              countries={data ? [data] : []}
              person={selectedPerson}
              onSuccess={() => setIsRequestOpen(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
}
